import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterWrapper = styled.footer`
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.light};
  padding: 40px 0 20px;
`;

const FooterContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 2fr;
  gap: 60px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const FooterColumn = styled.div`
  padding: 0 15px;
  
  &:first-child {
    padding-left: 0;
  }
  
  &:last-child {
    padding-right: 0;
  }
  
  @media (max-width: 768px) {
    margin-bottom: 20px;
    padding: 0;
  }
`;

const FooterLogo = styled.div`
  margin-bottom: 20px;
  
  img {
    height: 80px;
    width: auto;
    filter: brightness(0) invert(1);
  }
`;

const FooterAbout = styled.div`
  margin-bottom: 20px;
  
  p {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 0;
    line-height: 1.5;
  }
`;

const ColumnTitle = styled.h3`
  color: white;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
`;

const FooterLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 10px;
  
  a {
    color: rgba(255, 255, 255, 0.8);
    
    &:hover {
      color: white;
    }
  }
`;

const FooterContact = styled.div`
  p {
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 10px;
    line-height: 1.5;
  }
  
  a {
    color: rgba(255, 255, 255, 0.8);
    
    &:hover {
      color: white;
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 30px;
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
`;

const Copyright = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 0;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
  
  a {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    
    &:hover {
      color: white;
    }
  }
`;

const Footer = () => {
    return (
        <FooterWrapper>
            <FooterContainer>
                <FooterGrid>
                    <FooterColumn>
                        <FooterLogo>
                            <img src="/logo_decko_vecto.png" alt="Decko Logo" />
                        </FooterLogo>
                        <FooterAbout>
                            <p>
                                Créateur de vos parquets de jardin depuis 1985. Notre expertise artisanale au service de vos extérieurs.
                            </p>
                        </FooterAbout>
                    </FooterColumn>

                    <FooterColumn>
                        <ColumnTitle>Navigation</ColumnTitle>
                        <FooterLinks>
                            {[
                                { path: '/', text: 'Accueil' },
                                { path: '/entreprise', text: 'Entreprise' },
                                { path: '/techniques', text: 'Techniques' },
                                { path: '/realisations', text: 'Réalisations' },
                                { path: '/blog', text: 'Blog' },
                                { path: '/contact', text: 'Contact' }
                            ].map(link => (
                                <FooterLink key={link.path}>
                                    <Link to={link.path}>{link.text}</Link>
                                </FooterLink>
                            ))}
                        </FooterLinks>
                    </FooterColumn>

                    <FooterColumn>
                        <ColumnTitle>Contact</ColumnTitle>
                        <FooterContact>
                            <p>Siège : 15, rue du Moulin des Ratelles</p>
                            <p>Atelier : 20 Rue du Patis ZA du Patis</p>
                            <p>44690 LA HAYE FOUASSIÈRE</p>
                            <p>
                                <a href="tel:+33240133097">02 40 13 30 97</a><br />
                                <a href="tel:+33683589905">06 83 58 99 05</a>
                            </p>
                        </FooterContact>
                    </FooterColumn>
                </FooterGrid>

                <FooterBottom>
                    <Copyright>
                        &copy; {new Date().getFullYear()} Decko. Tous droits réservés.
                    </Copyright>
                    <LegalLinks>
                        <Link to="/mentions-legales">Mentions légales</Link>
                        <Link to="/politique-confidentialite">Politique de confidentialité</Link>
                    </LegalLinks>
                </FooterBottom>
            </FooterContainer>
        </FooterWrapper>
    );
};

export default Footer;